<template>
  <div id="components-layout-demo-basic" style="background: #ececec">
    <a-layout>
      <a-layout-header>课后服务开放平台</a-layout-header>
    </a-layout>
    <div v-if="loading" style="text-align: center;margin-top: 40vh;"><a-spin></a-spin></div>
    <div class="page-border" v-else>
      <div class="content-card">
        <div class="group1">
          <span class="word1" v-if="this.state.status === 3">完善个人资料</span>
          <span class="word1" v-if="this.state.status === 2">审核结果</span>
        </div>
      </div>
      <a-card :bordered="false" class="content-card">
        <div class="header" v-if="this.state.status === 3">
          <img class="pic1" referrerpolicy="no-referrer" src="/icon/reg/r2.png" />
          <div class="wrap1">
            <span class="word3">请尽快完善您的个人资料</span>
            <span class="word4">在待提交状态时，您可以随时补充或修改资料。一旦进入到审核流程将不能修改。</span>
          </div>
        </div>
        <div class="header" v-if="this.state.status === 2">
          <img class="pic1" referrerpolicy="no-referrer" src="/icon/reg/reject.png" />
          <div class="wrap1">
            <span class="word3">审核未通过</span>
            <span class="word4" style="display: block">不通过原因：{{ state.failReason }}</span>
            <span class="word4" style="display: block">审核时间：{{ state.failExamineDate }}</span>
            <span v-if="state.hasAttachment" class="word4" style="display: block">附件：{{ state.fileUrl }}
              <a @click="download" style="margin-left: 25px">下载</a></span>
          </div>
        </div>
        <div class="box3" style="margin-bottom: 30px"></div>
        <div v-if="showCopy" style="padding: 0 10px;">
          <div>您可在本页面完善信息并再次提交审核。</div>
          <div>
            或者您可以复制本页面链接地址，然后在电脑端粘贴打开链接并进行资料完善。
          </div>
          <div class="copy-btn">
            <a-button @click="copyCurrentUrl">点击复制链接地址</a-button>
            <input type="text" ref="urlInput" :value="currentUrl" style="position: absolute; left: -9999px;">
          </div>
          <div class="box3" style="margin-top: 30px"></div>
        </div>
        <!-- 个人 -->
        <div class="four-one">
          <TeacherInfo ref="teacherInfoRef" :scene="1" :state="state" :isMobile="isMobile"></TeacherInfo>
        </div>
      </a-card>
    </div>
  </div>
</template>
<script>
import bureau from "../../api/bureau";
import school from "../../api/school";
import user from "../../api/user";
import teacher from "../../api/teacher";
import CUpload from "../../components/CUpload";
import TeacherInfo from "./components/TeacherInfo.vue"
import Vue from "vue";
export default {
  components: {
    CUpload,
  },
  data() {
    return {
      state: {
        gender: 1,
        intro: "",
        degreeCertificatList: [
          {
            photoUrl: "",
            photoUrlList: [],
            text: "",
            eduBackground: "",
            photoUrl2: "",
            photoUrl2List: [],
          },
        ],
        auditFailed: true,
      },
      requiredSetting: [],
      isMobile: false,
      currentUrl: window.location.href,
      showCopy: false,
      loading: true,
    };
  },
  components: { TeacherInfo },
  created() {
    if (location.search.match(/webtoken=([\w\.\-_]+)(&|$)/) && location.search.match(/webtoken=([\w\.\-_]+)(&|$)/)[1]) {
      this.$ls.set("token", location.search.match(/webtoken=([\w\.\-_]+)(&|$)/)[1]);
    }
    if (this.state.status === 2) {
      this.state.auditFailed = false;
    }
    bureau.getBureauId().then((res) => {
      Vue.ls.set('bureauId',res)
      this.initInfo()
    })
  },
  mounted() {
    this.checkMobile();
    window.addEventListener("resize", this.checkMobile);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkMobile)
  },
  methods: {
    initInfo() {
      teacher.getMyself().then((res) => {
        Promise.all([
          this.getTeacherRequiredFieldsById(res.data.userId),
          user.init()
        ]).then(() => {
          this.loading = false
          this.state = res.data
          this.$nextTick(() => {
            this.$refs.teacherInfoRef.requiredSetting = this.requiredSetting
          })
          this.$nextTick(() => {
            this.$refs.teacherInfoRef.dataBack(res.data)
          })
        })
        if (res.data.status === 3) {
          const h = this.$createElement;
          this.$info({
            title: "未提交审核",
            content: h("div", {}, [
              h("p", "您的信息还未提交，请完善信息后点击-提交-送审。"),
            ]),
          });
        }
      });
    },
    // 获取教师必填字段
    getTeacherRequiredFieldsById(id) {
      new Promise((resolve, reject) => { 
        school.getTeacherRequiredFieldsById(id).then((res) => {
          this.requiredSetting = res.data.settingKeyValueDTOS;
          resolve()
        });
      });
    },
    checkMobile() {
      const userAgent = navigator.userAgent || navigator.vendor || window.opera
      // 检测常见移动设备关键词
      this.isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|MicroMessenger/i.test(userAgent)
      this.showCopy = this.isMobile
      // 适配窗口小于800px
      this.isMobile = this.isMobile || window.innerWidth <= 800
    },
    // 复制当前URL
    async copyCurrentUrl() {
      try {
        // 优先使用现代Clipboard API
        if (navigator.clipboard) {
          await navigator.clipboard.writeText(this.currentUrl);
          this.$message.success('链接已复制到剪贴板');
        } else {
          // 兼容旧浏览器的回退方案
          this.fallbackCopyUrl();
        }
      } catch (err) {
        // 如果Clipboard API失败，使用回退方案
        this.fallbackCopyUrl();
      }
    },

    // 兼容性复制方案
    fallbackCopyUrl() {
      const input = this.$refs.urlInput;
      input.select();
      input.setSelectionRange(0, 99999); // 对于移动设备很重要
      try {
        const successful = document.execCommand('copy');
        if (successful) {
          this.$message.success('链接已复制到剪贴板');
        } else {
          this.$message.success('链接复制失败');
        }
      } catch (err) {
        this.$message.success('链接复制失败');
      }
      // 有些设备会自动弹出键盘，需要手动失焦
      input.blur();
    },
    download() {
      teacher.getFile();
    },
  },
};
</script>

<style lang="scss" scoped>
@import "src/config/var";
@media screen and (min-width: 1280px) {
  div.page-border {
    padding-top: 108px;
    height: 100%;
  }
}

@media screen and (max-width: 1280px) {
  div.page-border {
    padding-top: 28px;
    padding-right: 10px;
    padding-left: 10px;
    height: 100%;
  }
}

div.page-border {
  background: #ececec;
}

.content-card {
  max-width: 1080px;
  width: 100%;
  margin-left: auto;
  margin-right: auto;
}

#components-layout-demo-basic {
  text-align: left;
  height: 100vh;
  overflow: auto;
}

#components-layout-demo-basic .ant-layout-header {
  background: #0b0b0f;
  color: #ffffff;
  font-size: 24px;
}

.ant-card {
  border-radius: 20px;
}

.group1 {
  height: 40px;
  padding-left: 30px;
}

.word1 {
  font-size: 24px;
  color: rgba(27, 29, 38, 1);
  line-height: 22px;
}

.header {
  margin: 13px 0 0 6px;
}

.pic1 {
  z-index: 23;
  width: 50px;
  height: 50px;
}

.wrap1 {
  display: inline-block;
  vertical-align: top;
  margin-left: 23px;

  .word3 {
    display: block;
    color: rgba(0, 0, 0, 0.85);
    font-size: 16px;
    font-family: PingFangSC-Semibold;
  }

  .word4 {
    color: rgba(135, 136, 138, 1);
    font-size: 14px;
    font-family: PingFangSC-Regular;
    margin-top: 8px;
  }
}

.box3 {
  z-index: 19;
  width: calc(100% - 20px);
  height: 4px;
  background-color: rgba(235, 241, 253, 1);
  align-self: center;
  margin: 37px 10px 40px 10px;
}

.copy-btn {
  text-align: center;
  margin-top: 16px;
}
</style>
